import { render, staticRenderFns } from "./ApprovedBookings.vue?vue&type=template&id=f7492948&scoped=true"
import script from "./ApprovedBookings.vue?vue&type=script&lang=js"
export * from "./ApprovedBookings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7492948",
  null
  
)

export default component.exports